import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Flex, Box } from '@chakra-ui/react';
import Header from '../components/Header';
import PageContent from '../components/PageContent';
import GeneralTab from '../components/settings/GeneralTab';

const BusinessSettings = () => {
  const { t } = useTranslation();
  const { businessId } = useParams<{ businessId: string }>();

  return (
    <Flex minHeight="100vh" direction="column" backgroundColor="neutral.900">
      <Header businessId={businessId} />

      <Flex flex="1" direction="column">
        <PageContent>
          <Flex direction="column" gap="32px">
            <Box
              fontSize="32px"
              fontWeight="500"
              color="neutral.100"
            >
              {t('settings.settings')}
            </Box>

            <GeneralTab />
          </Flex>
        </PageContent>
      </Flex>
    </Flex>
  );
};

export default BusinessSettings;
